import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
  Col,
  Row,
  Radio,
  Input,
  Checkbox,
  Form,
  Button,
  InputNumber,
  message,
} from "antd";
import DATA from "./questionform";
// import { getStyleProperties } from "../../../utils/CustomFunc";
// import axios from "../../utils/BasicAuthAPI";
import "./storm.css";
import queryString from "query-string";
import { useHistory } from "react-router";
import { useLocation } from "react-router-dom";
import liracrypt from "../Liracrypt/liracrypt";
import ApiErrorComp from "../ApiErrorComp/ApiErrorComp";
import SessionError from "../ApiErrorComp/SessionError";
import { getStyleProperties } from "../../utils/CustomFunc";
import FormElement from "./FormElement";
import ButtonPicker from "../ReportFormGenerator/Button/Button";
import AdvanceButton from "../ReportFormGenerator/AdvanceButton/AdvanceButton";
import moment from "moment";
import TextBox from "../ReportFormGenerator/TextBox/TextBox";
import HModal from "../../pages/HModal";
import FooterButtons from "./FooterButtons";
import ZenMultiLines from "../PhantomZen/ZenMultiLines";
import RoutePage from "../RoutePage";
import { useSelector } from "react-redux";
import MultiTextDynamic from "../MultiTextDynamic";


const QcRecordStormPrime = (props) => {
  let { docNo } = useParams();
  const urlCode = useSelector(state => state.urlCode);
  if (props.urlData) {
    docNo = props.urlData.docNo
  };
  let history = useHistory();
  let location = useLocation();
  const [selectedRowData, setSelectedRowData] = useState([]);
  const [selectedButton, setSelectedButton] = useState();
  const [isHModalVisible, setIsHModalVisible] = useState(false);
  const [action, setAction] = useState({});
  const searchParams = queryString.parse(location.search);
  const [stormResponse, setStormResponse] = useState(null);
  const [examDetail, setExamDetail] = useState(null);
  const [loginError, setLoginError] = useState(false);
  const [defaultValue, setDefaultValue] = useState(null);
  const { TextArea } = Input;
  if (props.setPageHeader) {
    props.setPageHeader("");
  };
  const [form] = Form.useForm();
  const [advanceBtnIndex, setAdvanceBtnIndex] = useState(0);

  const fetchAPI = () => {
    let urlData = { ...searchParams, docNo };
    liracrypt
      .get("/manpowerdeployment/shiftdeployment", urlData)
      .then(({ data }) => {
        setStormResponse(data);
      })
      .catch(function (error) {
        // message.error('ERROR: Unable to save!', 4);
        console.log("Error****:");
        if (error.response !== undefined) {
          if (error.response.status !== 401) {
            ApiErrorComp(error.response.status);
          } else {
            setLoginError(true);
          }
        }
      });
  };

  useEffect(() => {
    fetchAPI();

    // setStormResponse(DATA);
  }, []);




  const onResponse = ({ data, button, onlyPostSubmitAction }) => {
    // setStormResponse(data);
    if (data) {
      message.success(
        data?.message
          ? data?.message
          : "Submitted Successfully"
      );
    };
    let btnData = button || selectedButton;
    if (btnData.buttonProp?.popUpModal && !onlyPostSubmitAction) {
      return openPopupModal(btnData);
    };
    if (!btnData?.buttonProp?.postSubmitAction) {
      return;
    };
    if (btnData?.postSubmitActionProp?.action === "clearForm") {
      form.resetFields();

    }
    if (btnData?.postSubmitActionProp?.action === "blankPage") {
      setStormResponse(null);
    };
    if (btnData?.postSubmitActionProp?.action === "reloadStorm") {
      setStormResponse(null);
      fetchAPI();
    }
    if (btnData?.postSubmitActionProp?.action === "newTab") {
      window.open(`/v02/${urlCode}` + btnData.postSubmitActionProp.route, '_blank');
    };

    if (btnData?.postSubmitActionProp?.action === 'reloadPage') {
      window.location.reload();
    }
  };

  const openPopupModal = (button) => {
    setIsHModalVisible(true);
    setAction({ edit: button.popUpModalProp });
  }

  const onResponseError = (error) => {
    console.log("Error****:");
    if (error.response !== undefined) {
      if (error.response.status !== 401) {
        ApiErrorComp(error.response.status);
      } else {
        setLoginError(true);
      }
    }
  }

  const postData = (data) => {
    const datetimes = stormResponse.data.filter(
      (obj) =>
        ["dateTimePicker", "datePicker"].indexOf(obj.typ) > -1 && obj.format
    );
    const rangePicker = stormResponse.data.filter(
      (obj) => ["rangePicker"].indexOf(obj.typ) > -1
    );

    for (const idx in rangePicker) {
      data = {
        ...data,
        [rangePicker[idx]["_id"]]: [
          moment(data[rangePicker[idx]["_id"]][0]).format(
            rangePicker[idx].format ? rangePicker[idx].format : "YYYY-MM-DD"
          ),
          moment(data[rangePicker[idx]["_id"]][1]).format(
            rangePicker[idx].format ? rangePicker[idx].format : "YYYY-MM-DD"
          ),
        ],
      };
    }

    for (const idx in datetimes) {
      data = {
        ...data,
        [datetimes[idx]["_id"]]: moment(data[datetimes[idx]["_id"]]).format(
          datetimes[idx].format
        ),
      };
    };
    let updatedData = {};
    const objKeys = Object.keys(data);
    objKeys.forEach(x => {
      if (!x.includes('rmrk')) {
        if (!updatedData[x]) {
          updatedData[x] = {
            ans: data[x]
          };
        } else {
          updatedData[x].ans = data[x];
        }
      } else {
        let key = x.split("_")[1];
        if (!updatedData[key]) {
          updatedData[key] = {
            remark: data[x]
          };
        } else {
          updatedData[key].remark = data[x];
        }
      };
    });
    if (selectedButton?.submitFormDataProp?.method === 'PATCH') {
      liracrypt
        .patch(selectedButton?.submitFormDataProp?.url, { sessid: docNo, stormAnswerDict: updatedData, ...searchParams, ...selectedButton?.submitFormDataProp?.auxParam })
        .then(onResponse)
        .catch(onResponseError);
    };
    if (selectedButton?.submitFormDataProp.method === 'POST') {
      liracrypt
        .post(selectedButton?.submitFormDataProp?.url, { sessid: docNo, stormAnswerDict: updatedData, ...searchParams, ...selectedButton?.submitFormDataProp?.auxParam })
        .then(onResponse)
        .catch(onResponseError);
    };
  };

  const onFinishFailed = (e) => {

  };
  const onFinish = (data) => {
    postData(data);
  };

  const formStyle = (formConfig) => {
    const style = {
      width: formConfig.formWidth ? formConfig.formWidth : "1000px",
      background: `linear-gradient(to right, ${formConfig.DivBackgroundColor[0]}, ${formConfig.DivBackgroundColor[1]})`,
      align: formConfig.DivAlignment ? formConfig.DivAlignment : "center",
      marginLeft: formConfig.LeftMargin ? formConfig.LeftMargin : "0px",
      paddingLeft: formConfig.InnerLeftPadding
        ? formConfig.InnerLeftPadding
        : "15px",
      paddingRight: formConfig.InnerRightPadding
        ? formConfig.InnerRightPadding
        : "15px",
    };

    if (formConfig["line-color"]) {
      style["borderBottom"] = `1px solid formConfig["line-color"]`;
    }

    return style;
  };


  const auxLines = ({ spec, aux1, aux2, aux3, aux4 }) => (spec || aux1 || aux2 || aux3 || aux4) ? (
    <div className="aux-lines">
      {
        spec && (
          <p style={{
            ...getStyleProperties(stormResponse?.config?.spec),
            padding: stormResponse?.config?.spec["row-padding"],
          }}>
            <span>{stormResponse?.config?.spec.prefix}</span>
            <span>{spec}</span>
          </p>
        )
      }



      {
        aux1 && (
          <p style={{
            ...getStyleProperties(stormResponse?.config?.aux1),
            padding: stormResponse?.config?.aux1["row-padding"],
          }}>
            <span>{stormResponse?.config?.aux1.prefix}</span>
            <span>{aux1}</span>
          </p>
        )
      }
      {
        aux2 && (
          <p style={{
            ...getStyleProperties(stormResponse?.config?.aux2),
            padding: stormResponse?.config?.aux2["row-padding"],
          }}>
            <span>{stormResponse?.config?.aux2.prefix}</span>
            <span>{aux2}</span>
          </p>
        )
      }
      {
        aux3 && (
          <p style={{
            ...getStyleProperties(stormResponse?.config?.aux3),
            padding: stormResponse?.config?.aux3["row-padding"],
          }}>
            <span>{stormResponse?.config?.aux3.prefix}</span>
            <span>{aux3}</span>
          </p>
        )
      }
      {
        aux4 && (
          <p style={{
            ...getStyleProperties(stormResponse?.config?.aux4),
            padding: stormResponse?.config?.aux4["row-padding"],
          }}>
            <span>{stormResponse?.config?.aux4.prefix}</span>
            <span>{aux4}</span>
          </p>
        )
      }
    </div>
  ) : null;

  const RemarkTextBox = (elem) => {
    if (elem.rmrk) {
      form.setFieldsValue({ [`rmrk_${elem._id}`]: defaultValue });
    }
    return (
      <TextBox
        className="remarkTxtBox"
        form={form}
        name={`rmrk_${elem._id}`}
        label=""
        // disabled={elem.readOnly ? true : false}
        // required={elem.required ? elem.required : false}
        defaultValue={elem.rmrk ? elem["rmrk"] : null}
        type="input"
        // errorMessage={elem.errorMessage ? elem.errorMessage : "invalid!"}
        placeholder={"Remark"}
      />
    )
  }

  const QusAns = (question, form) => {
    let { spec, aux1, aux2, aux3, aux4, rmrkTxtBox } = question;
    return (
      <>
        <Col
          key={"qus" + question._id + question.seq}
          span={24}
          style={{ padding: "10px 10px" }}
        >
          {/* {
            (question.seq || question.param) ?
              <p
                className="question"
                style={{
                  ...getStyleProperties(stormResponse?.config?.question),
                  padding: stormResponse?.config?.question["row-padding"],
                }}
              >
                <span>{question.seq}:</span> {question.param}
              </p> : null
          }

          {auxLines({ spec, aux1, aux2, aux3, aux4 })} */}
          <MultiTextDynamic record={question}
            data={stormResponse?.config?.blockConfig?.blocks[question.block]}
            containerStyle={stormResponse?.config?.blockConfig?.containerStyle}
          />


          <div
            style={{
              ...getStyleProperties(stormResponse?.config["answer "]),
              // padding: stormResponse?.config["answer"]["row-padding"],
            }}
          >
            <div className="form-group" style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
              <FormElement elemData={question} form={form} />
              {
                rmrkTxtBox && (
                  RemarkTextBox(question)
                )
              }
            </div>
          </div>
        </Col>
      </>
    );
  };

  const getButton = (button, form) => {
    return (
      <>
        <Col span={24} style={{ padding: "10px 10px" }}>
          <p
            className="question"
            style={{
              ...getStyleProperties(stormResponse?.config?.rows),
              padding: stormResponse?.config?.rows["row-padding"],
            }}
          >
            {/* <span>{question.qno}:</span> {question.qtn} */}
          </p>

          {/* <FormElement elemData={question} form={form} /> */}
        </Col>
      </>
    );
  };

  const getFooter = (footer, footerNotes) => {
    return (
      <Row className="storm-footer">
        <Col
          span={24}
          style={{
            ...getStyleProperties(footer),
            padding: footer["row-padding"],
          }}
        ></Col>
        <Col span={24}>
          <ul style={{ listStyle: "none", paddingLeft: "0px" }}>
            {footerNotes.map((fItem, index) => {
              return (
                <li
                  style={{
                    ...getStyleProperties(fItem),
                    padding: fItem["row-padding"]
                      ? fItem["row-padding"]
                      : "5px",
                  }}
                >
                  {fItem["text"]}
                </li>
              );
            })}
          </ul>
        </Col>
      </Row>
    );
  };

  const getHeader = (title, subtitle, header1, header2, header3, header4) => {
    return (
      <Row
        className="storm-header"
        style={{
          ...getStyleProperties(title),
          padding: title["row-padding"],
        }}
      >
        <Col
          span={24}
          style={{
            ...getStyleProperties(title),
            textAlign: title["align"] ? title["align"] : "left",
            padding: title["row-padding"] ? title["row-padding"] : 0,
          }}
        >
          <span>{title["label"]}</span>
        </Col>
        <Col
          span={24}
          style={{
            ...getStyleProperties(subtitle),
            padding: subtitle["row-padding"] ? subtitle["row-padding"] : 0,
            textAlign: subtitle["align"] ? subtitle["align"] : "left",
          }}
        >
          <span>{subtitle["label"]}</span>
        </Col>
        <Col
          span={24}
          style={{
            ...getStyleProperties(header1),
            padding: header1["row-padding"] ? header1["row-padding"] : 0,
            textAlign: header1["align"] ? header1["align"] : "left",
          }}
        >
          <span>{header1["label"]}</span>
        </Col>


        <Col
          span={24}
          style={{
            ...getStyleProperties(header2),
            padding: header2["row-padding"] ? header2["row-padding"] : 0,
            textAlign: header2["align"] ? header2["align"] : "left",
          }}
        >
          <span>{header2["label"]}</span>
        </Col>

        <Col
          span={24}
          style={{
            ...getStyleProperties(header3),
            padding: header3["row-padding"] ? header3["row-padding"] : 0,
            textAlign: header3["align"] ? header3["align"] : "left",
          }}
        >
          <span>{header3["label"]}</span>
        </Col>

        <Col
          span={24}
          style={{
            ...getStyleProperties(header4),
            padding: header4["row-padding"] ? header4["row-padding"] : 0,
            textAlign: header4["align"] ? header4["align"] : "left",
          }}
        >
          <span>{header4["label"]}</span>
        </Col>


      </Row>
    );
  };


  const EModal = (
    <HModal
      onResponse={onResponse}
      isModalVisible={isHModalVisible}
      setIsModalVisible={setIsHModalVisible}
      modalMethod={"edit"}
      action={action}
      modalData={null}
      extraData={selectedRowData}
      preventSubmitBtnClick={true}
    />
  )

  return (
    <React.Fragment>
      {stormResponse && stormResponse.config && (
        <Row className="storm-custom">
          <Col span={24}>
            {
              (stormResponse.config?.zenFuncs?.headerRoute && stormResponse.config?.headerRoute?.route) ?
                <Row>
                  <Col span={24}>
                    <div style={{ width: '500px', display: 'block', margin: 'auto' }}>
                      <RoutePage route={stormResponse.config?.headerRoute?.route} params={{ ...searchParams, ...props.urlData || {}, ...stormResponse.config?.headerRoute?.params }} />
                    </div>
                  </Col>
                </Row>
                : <></>
            }
            <ZenMultiLines style={{ backgroundColor: stormResponse.config?.headerMultiline?.['background-color'] || 'transparent' }} classes="zen-multi-header" visible={stormResponse.config?.zenFuncs?.headerMultiline || false} singleLineColumns={stormResponse.config?.headerMultiline?.singleCol || []} multiLineColumns={stormResponse.config?.headerMultiline?.multiCol || []} />
            {/* {getHeader(

              stormResponse.config?.formTitle,
              stormResponse.config?.formSubTitle,
              stormResponse.config?.header1,
              stormResponse.config?.header2,
              stormResponse.config?.header3,
              stormResponse.config?.header4
            )} */}
          </Col>
          <Col span={24}>
            <div style={{ borderTop: "3px solid #2ecc71 ", marginLeft: 0, marginRight: 0 }}></div>

            <div style={formStyle(stormResponse.config.formConfig)}>
              <Form
                name="ReportForm"
                form={form}
                labelCol={{ span: 8 }}
                wrapperCol={{ span: 16 }}
                layout="horizontal"
                colon={false}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                size="large"
              >
                {stormResponse.data.map((question) => QusAns(question, form))}
                <Col span={24} style={{ padding: "0px 0px", display: 'inline-flex', width: '100%', justifyContent: 'space-around' }}>
                  {Object.keys(stormResponse.config.footerButtons).map((btn, index) => {
                    const button = stormResponse.config.footerButtons[btn];
                    if (button?.buttonProp?.visible) {
                      return (
                        <FooterButtons
                          postSubmitAction={onResponse}
                          openPopupModal={openPopupModal}
                          button={button}
                          setSelectedButton={setSelectedButton}
                          btnIndex={index}
                          setAdvanceBtnIndex={setAdvanceBtnIndex}
                          form={form}
                          label={button?.buttonProp?.label}
                          type={button?.buttonProp?.type}
                          disabled={!button?.buttonProp?.enable}
                          confirmationPopUp={button?.buttonProp?.confirmationPopUp ? button?.confirmationPopUpProp : undefined}
                          submitFormData={button?.submitFormDataProp}
                        />
                      )
                    }
                  })}
                </Col>
              </Form>
            </div>
          </Col>
          <Col span={24}>
            {/* {getFooter(
              stormResponse.config?.footer,
              stormResponse.config?.footerNotes
            )} */}
            <div style={{ marginTop: 20 }}>
              <ZenMultiLines style={{ backgroundColor: stormResponse.config?.footerMultiline?.['background-color'] || 'transparent' }} classes="zen-multi-header" visible={stormResponse.config?.zenFuncs?.footerMultiline || false} singleLineColumns={stormResponse.config?.footerMultiline?.singleCol || []} multiLineColumns={stormResponse.config?.footerMultiline?.multiCol || []} />
            </div>
          </Col>
        </Row>
      )}
      {EModal}
    </React.Fragment>
  );
};
export default QcRecordStormPrime;
